/**
 * WordPress dependencies.
 */
import { Component, Fragment } from '@wordpress/element';
import { ResizableBox, Disabled, Button, Toolbar, Placeholder, TextControl, Icon } from '@wordpress/components';
import {
	BlockControls,
} from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

import Inspector from './inspector';
import { generateCustomStyleCode } from '../../extensions/custom-styles';
import BaseWrapper from '../../components/base-wrapper';

class edit extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			locationState: '',
		};
		this.updateState = this.updateState.bind( this );
	}

	updateState( data ) {
		this.setState( ( prevValue ) => {
			return {
				...prevValue,
				...data,
			};
		} );
	}

	componentDidMount() {
		const {
			attributes,
			setAttributes,
			clientId,
		} = this.props;
		const { location, blockAdvanceOptions, isSaved } = attributes;

		this.updateState( {
			locationState: location,
		} );

		setAttributes( {
			pinned: '' !== location,
		} );

		let saveIt = false;
		if ( ! isSaved ) {
			setAttributes( { isSaved: true, blockClientId: clientId } );
			saveIt = true;
		}
		generateCustomStyleCode( blockAdvanceOptions, { ...this.props }, saveIt );
	}

	componentDidUpdate() {
		const {
			attributes,
			isSelected,
			setAttributes,
		} = this.props;
		const { location } = attributes;
		if ( ! isSelected && '' === location ) {
			setAttributes( {
				pinned: false,
			} );
		}
	}

	render() {
		const {
			attributes,
			isSelected,
			setAttributes,
			toggleSelection,
			className,
		} = this.props;
		const { location, height, pinned, width, zoom, language } = attributes;

		return <div className={ className }>
			{ isSelected && <BlockControls>
				{ '' !== location && <Toolbar>
					<Button isPressed={ ! pinned } icon="edit" showTooltip={ true } label={ __( 'Edit' ) } className={ 'components-toolbar-button' } onClick={ () => {
						setAttributes( {
							pinned: ! pinned,
						} );
					} } />
				</Toolbar> }
			</BlockControls> }
			{ isSelected && <Inspector { ...this.props } /> }
			{ ! pinned && <Fragment>
				<Placeholder icon={ <Icon icon="location-alt" /> }
					label={ __( 'Map', 'coblocks' ) }
					instructions={ __(
						'Enter a location or address to drop a pin on a Google map.'
					) }>
					<TextControl onChange={ ( val ) => {
						this.updateState( { locationState: val } );
					} } value={ this.state.locationState } />
					<Button onClick={ () => {
						if ( '' !== this.state.locationState ) {
							setAttributes( {
								location: this.state.locationState,
								pinned: true,
							} );
						}
					} } disabled={ '' === this.state.locationState }>Save</Button>
				</Placeholder>
			</Fragment> }
			{ !! pinned && <ResizableBox
				showHandle={ isSelected }
				size={ {
					height,
					width: '100%',
				} }
				minHeight="200"
				enable={ {
					bottom: true,
					bottomLeft: false,
					bottomRight: false,
					left: false,
					right: false,
					top: false,
					topLeft: false,
					topRight: false,
				} }
				onResizeStop={ ( event, direction, elt, delta ) => {
					setAttributes( {
						height: parseInt( height + delta.height, 10 ),
						width: parseInt( width + delta.width, 10 ),
					} );
					toggleSelection( true );
				} }
				onResizeStart={ () => {
					toggleSelection( false );
				} }
			>
				<Disabled>
					<BaseWrapper { ...this.props }>
						<iframe title="Google Map" frameBorder={ 0 } src={ `https://www.google.com/maps?q=${ encodeURIComponent( location ) }&output=embed&hl=${ language }&z=${ zoom }` } style={ { minHeight: `${ height }px`, width: `100%` } }></iframe>
					</BaseWrapper>
				</Disabled>
			</ResizableBox> }
		</div>;
	}
}

export default edit;
